import { Column, CreateDateColumn, Entity, VersionColumn, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Entity("freebie")
export class FreebieEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "freebie_id"
    })
    freebieId: number;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "category"
    })
    category: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "freebie_code"
    })
    freebieCode: string;

    @Column({
        type: "decimal",
        nullable: false,
        precision: 5,
        scale: 3,
        name: "unit_price"
    })
    unitPrice: number;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "description"
    })
    description: string;

    @Column("tinyint", {
        nullable: false,
        name: "start_hour"
    })
    startHour: number;

    @Column("tinyint", {
        nullable: false,
        name: "start_minutes"
    })
    startMinutes: number;

    @Column("tinyint", {
        nullable: false,
        name: "end_hour"
    })
    endHour: number;

    @Column("tinyint", {
        nullable: false,
        name: "end_minutes"
    })
    endMinutes: number;

    @Column("int", {
        nullable: false,
        name: "department_id"
    })
    departmentId: number;

    @Column("int", {
        nullable: false,
        name: "company_id"
    })
    companyId: number;

    @Column("tinyint", {
        nullable: false,
        name: "job_hour"
    })
    jobHour: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean | null;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    // @Column("date",{
    //     name:"start_time"
    // })
    // startTime: Date;

    // @Column("date",{
    //     name:"end_time"
    // })
    // endTime: Date;

}